import { render } from "./InstanceView.vue?vue&type=template&id=505ba483&scoped=true&ts=true"
import script from "./InstanceView.vue?vue&type=script&lang=ts"
export * from "./InstanceView.vue?vue&type=script&lang=ts"

import "./InstanceView.vue?vue&type=style&index=0&id=505ba483&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505ba483"]])

export default __exports__